import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef
} from '@angular/core';


export class SkyDropdownItemComponent implements AfterViewInit {
  public isActive = false;
  public isDisabled = false;
  public buttonElement: HTMLButtonElement;

  public constructor(
    public elementRef: ElementRef,
    private changeDetector: ChangeDetectorRef
  ) { }

  public ngAfterViewInit() {
    this.buttonElement = this.elementRef.nativeElement.querySelector('button');
    this.isDisabled = !this.isFocusable();
    this.changeDetector.detectChanges();
  }

  public focusElement(enableNativeFocus: boolean) {
    this.isActive = true;

    if (enableNativeFocus) {
      this.buttonElement.focus();
    }

    this.changeDetector.detectChanges();
  }

  public isFocusable(): boolean {
    /*tslint:disable no-null-keyword */
    const isFocusable = (
      this.buttonElement &&
      this.buttonElement.getAttribute('disabled') === null
    );
    /*tslint:enable */
    return isFocusable;
  }

  public resetState() {
    this.isActive = false;
    this.changeDetector.markForCheck();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-dropdown-item',
  template: `<div
  class="sky-dropdown-item"
  [ngClass]="{
    'sky-dropdown-item-active': isActive,
    'sky-dropdown-item-disabled': isDisabled
  }">
  <ng-content>
  </ng-content>
</div>
`,
  styles: [`.sky-dropdown-item {
  background-color: transparent;
  border: none;
  display: block;
  margin: 4px;
  min-width: 160px;
  text-align: left;
  transition: background-color 150ms;
}

.sky-dropdown-item.sky-dropdown-item-active, .sky-dropdown-item:hover {
  background-color: #eeeeef;
}

.sky-dropdown-item.sky-dropdown-item-disabled {
  cursor: default;
}

.sky-dropdown-item.sky-dropdown-item-disabled:hover {
  background-color: transparent;
}

.sky-dropdown-item ::ng-deep > button {
  background-color: transparent;
  border: none;
  color: #282b31;
  cursor: pointer;
  display: block;
  padding: 3px 20px;
  text-align: left;
  width: 100%;
}

.sky-dropdown-item ::ng-deep > button[disabled] {
  color: #686c73;
}

.sky-dropdown-item ::ng-deep > button[disabled]:hover {
  cursor: default;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: ChangeDetectorRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
